import Vue from 'vue'
import Vuex from 'vuex'

import translation from './modules/translation'
import user from './modules/user'
import cart from './modules/cart'
import checkout from './modules/checkout/checkout'
import contactsForm from './modules/checkout/contactsForm'
import deliveryForm from './modules/checkout/deliveryForm'
import paymentForm from './modules/checkout/paymentForm'
import products from './modules/products'
import thankYouPage from './modules/checkout/thankYouPage'
import bonuses from './modules/bonuses'
import qualityControl from './modules/qualityControl'
import productComparison from './modules/productComparison'
import chats from './modules/chats'
import search from './modules/search'
import productTabs from './modules/product-page/productTabs'
import productInfo from './modules/product-page/productInfo'
import productGallery from './modules/product-page/productGallery'
import videoGallery from './modules/product-page/videoGallery'
import geoLocation from './modules/geoLocation'
import map from './modules/map'
import init from './modules/init'
import youtube from './modules/youtube'
import shops from './modules/shops'
import cabinet from './modules/cabinet/index'
import comments from './modules/comments'
import questions from './modules/questions'
import abTesting from './modules/abTesting'
import microdata from './modules/microdata'

Vue.config.devtools = window.config?.['vue_debug_enabled']

Vue.use(Vuex)

export default new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production',
  modules: {
    translation,
    user,
    cart,
    products,
    checkout,
    bonuses,
    thankYouPage,
    qualityControl,
    productComparison,
    contactsForm,
    deliveryForm,
    paymentForm,
    chats,
    search,
    productTabs,
    productInfo,
    productGallery,
    videoGallery,
    map,
    geoLocation,
    init,
    youtube,
    cabinet,
    comments,
    questions,
    shops,
    abTesting,
    microdata
  }
})
